export const roundUpOptions = [
  {
    label: '10 Cent',
    value: '10cent',
  },
  {
    label: '1 Euro',
    value: '1euro',
  },
];